import { Link } from 'react-router-dom'
import './Admin.css'

type Tool = {
  slug: string
  name: string
  blurb: string
}

const TOOLS: Tool[] = [
  {
    slug: 'generate-alphabet',
    name: 'Generate Alphabet',
    blurb: 'Generate A–Z mp3s (128 kbps, 44.1 kHz) via ElevenLabs TTS and save them to disk.',
  },
  {
    slug: 'make-app',
    name: 'Make App',
    blurb: 'Package a firmware build into a toy. Type project + gitHash, drop files, upload.',
  },
]

export default function AdminTools() {
  return (
    <section className="admin">
      <h1 className="page-title">Admin Tools</h1>
      <p className="page-lede">Utilities for operators. Each tool runs in your browser.</p>

      <ul className="admin__list">
        {TOOLS.map((t) => (
          <li key={t.slug}>
            <Link to={`/admin-tools/${t.slug}`}>
              <strong>{t.name}</strong>
              <div className="admin-user__toy-description">{t.blurb}</div>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  )
}
